// extracted by mini-css-extract-plugin
export default {"largeLink":"largeLink-module--largeLink--e0500","arrow":"largeLink-module--arrow--03314"};